import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../shared-components/LoadingSpinner";

export const CompanySubscriptions = () => {
  const { companyId: companyUUID, subid: subCompanyUUID } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new route
    if (subCompanyUUID) {
      navigate(
        `/companies/${companyUUID}/subcompany/${subCompanyUUID}/settings/subscriptions`
      );
    } else {
      navigate(`/companies/${companyUUID}/settings/subscriptions`);
    }
  }, [companyUUID, subCompanyUUID, navigate]);

  return <LoadingSpinner />;
};
